import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function BrazeMonoIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 21 21" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M9.487 12.026c.172-1.64 1.202-2.978 2.403-2.978 1.202 0 1.85 1.337 1.682 2.978-.168 1.64-1.165 2.998-2.293 2.998-1.123 0-2.038-1.03-1.792-2.998Zm1.013 7.448a8.947 8.947 0 0 1-6.911-3.244c1.489.476 3.15.057 4.45-1.222a4.3 4.3 0 0 0 .382-.44c.59 1.28 1.739 1.929 2.883 1.929 1.948 0 3.589-2.006 3.781-4.488.193-2.481-1.201-4.45-3.055-4.45a3.585 3.585 0 0 0-1.907.517l.574-3.343a.926.926 0 0 0-.172-.763c-.173-.266-.324-.381-.554-.381H7.297a.321.321 0 0 0-.304.287 7.49 7.49 0 0 0-.152.956c-.02.209.136.287.304.287h1.948c-.303 1.907-.914 5.61-1.087 6.55a4.714 4.714 0 0 1-1.243 2.35c-1.07 1.07-3.035 1.317-4.2.152-.406-.427-1.037-1.456-1.037-3.671A8.974 8.974 0 0 1 10.5 1.526a8.974 8.974 0 0 1 8.974 8.974 8.976 8.976 0 0 1-8.974 8.974ZM10.5 0C4.7 0 0 4.7 0 10.5S4.7 21 10.5 21 21 16.3 21 10.5A10.5 10.5 0 0 0 10.5 0Z"
      />
    </Icon>
  );
}
